// Thẻ "Công tắc": bật/tắt chương trình, từng mảng, danh sách tài khoản thử. Lưu RIÊNG khỏi cấu hình.
import { useState } from "react";
import { Alert, Button, Card, Col, Modal, Row, message } from "antd";
import { faCalendarCheck, faEye, faListCheck, faPowerOff, faRankingStar, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import xuProgramApi from "../../../api/xuProgramApi";
import XuBetaUserSelect from "./xu-beta-user-select";
import XuFlagTile from "./xu-flag-tile";
import { apiError } from "./xu-format-helpers";

const MASTER = {
    key: "global", icon: faPowerOff, title: "Chương trình Xu (công tắc tổng)",
    desc: "Tắt = app ẩn hết, mọi thao tác Xu bị từ chối. Dữ liệu không mất.",
    confirm: "Bật chương trình Xu? Người trong danh sách thử (hoặc mọi người nếu đã bật “Hiện cho mọi người”) sẽ thấy và nhận Xu thật.",
};
const TILES = [
    { key: "visible", icon: faEye, title: "Hiện cho mọi người", desc: "Tắt = chỉ tài khoản thử bên dưới thấy.", confirm: "Mở chương trình cho TẤT CẢ người dùng? Từ lúc này ai cũng điểm danh và nhận Xu thật.", onText: "Mọi người", offText: "Chỉ tài khoản thử" },
    { key: "checkin", icon: faCalendarCheck, title: "Điểm danh", desc: "Mỗi ngày bấm một lần để nhận Xu." },
    { key: "missions", icon: faListCheck, title: "Nhiệm vụ hằng ngày", desc: "3 nhiệm vụ mỗi ngày, làm xong bấm nhận Xu." },
    { key: "rank", icon: faRankingStar, title: "Hạng thành viên", desc: "Hạng càng cao, Xu nhận được càng nhân lên." },
];

export default function XuFlagsCard({ saved, draft, setDraft, betaUsers, onSaved }) {
    const [saving, setSaving] = useState(false);
    const dirty = JSON.stringify(saved) !== JSON.stringify(draft);

    const toggle = (row) => (checked) => {
        if (checked && row.confirm) {
            Modal.confirm({ title: row.title, content: row.confirm, okText: "Bật", cancelText: "Huỷ", onOk: () => setDraft({ ...draft, [row.key]: true }) });
        } else {
            setDraft({ ...draft, [row.key]: checked });
        }
    };

    const save = async () => {
        setSaving(true);
        try {
            const { data } = await xuProgramApi.saveFlags(draft);
            const { betaUsers: users, ...flags } = data.data;
            onSaved(flags, users);
            message.success("Đã lưu công tắc — áp dụng cho toàn bộ máy chủ trong tối đa 30 giây");
        } catch (e) {
            message.error(apiError(e, "Lưu công tắc thất bại"));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Card id="xu-sec-flags" className="shadow-sm scroll-mt-4" size="small"
            title={<span><FontAwesomeIcon icon={faToggleOn} className="text-indigo-500 mr-2" />Công tắc</span>}
            extra={<Button type="primary" loading={saving} disabled={!dirty} onClick={save}>{dirty ? "Lưu công tắc" : "Đã lưu"}</Button>}>
            <div className="space-y-3">
                <XuFlagTile big {...MASTER} checked={Boolean(draft.global)} onChange={toggle(MASTER)} onText="Đang BẬT" offText="Đang TẮT — người dùng chưa thấy gì" />
                <Row gutter={[12, 12]}>
                    {TILES.map((t) => (
                        <Col xs={24} md={12} key={t.key}><XuFlagTile {...t} checked={Boolean(draft[t.key])} onChange={toggle(t)} /></Col>
                    ))}
                </Row>
                <div>
                    <div className="font-medium mb-1">Tài khoản thử</div>
                    <div className="text-xs text-gray-500 mb-2">Những người này thấy và dùng được chương trình khi chưa bật “Hiện cho mọi người”.</div>
                    <XuBetaUserSelect ids={draft.betaUserIds} initialUsers={betaUsers} onChange={(ids) => setDraft({ ...draft, betaUserIds: ids })} />
                </div>
                <Alert type="info" showIcon message="Lưu xong, thay đổi có hiệu lực trong tối đa 30 giây." />
            </div>
        </Card>
    );
}
